import React, { FC, useState } from 'react'
import { showSuccessToast, validatePhoneNumber } from '../../../app/helper/functions';
import submitToSheet from '../../../app/utlis/submitToSheet';
import { trackClarityEvent } from '../../../app/utlis/ClarityAnalytics';
import { trackFirebaseEvent } from '../../../app/utlis/FirebaseAnalytics';
import { CLARITY_EVENTS } from '../../../app/utlis/EventTypes';
import Heading from '../../atoms/Heading/Heading';

interface ContactUsProps {
    data?: {
        title?: string;
        subTitle?: string;
        buttonText?: string;
    };
}

const ContactUs: FC<ContactUsProps> = ({ data }) => {
    const [formData, setFormData] = useState({
        FirstName: '',
        Email: '',
        PhoneNumber: '',
        Message: ''
    })

    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const sectionTitle = data?.title || "CONTACT US";
    const sectionSubTitle = data?.subTitle || "Let's discuss your opportunities.";
    const buttonText = data?.buttonText || "Contact Us";

    const onChangeForm = (e: any) => {
        const { value, name } = e.target;
        setErrorMessage('')
        setFormData({
            ...formData,
            [name]: value
        })
    }

    const onSubmit = async () => {
        if (!formData.FirstName || !formData.PhoneNumber || !validatePhoneNumber(formData.PhoneNumber)) {
            setErrorMessage('Please fill out all fields correctly');
            return;
        }

        try {
            setLoading(true);

            const payload = {
                source: 'contact_us_component',
                name: formData.FirstName,
            };
            trackClarityEvent(CLARITY_EVENTS.CONTACT_US_FORM, payload);
            trackFirebaseEvent(CLARITY_EVENTS.CONTACT_US_FORM, payload);

            // Store in Google Sheet
            await submitToSheet({
                source: 'Contact Us',
                name: formData.FirstName,
                mobileNo: formData.PhoneNumber,
                message: formData.Message
            });

            setFormData({
                FirstName: '',
                Email: '',
                PhoneNumber: '',
                Message: ''
            });

            showSuccessToast('Thank you for showing interest in Sattva Tech, We will contact you soon.');
        } catch (error) {
            console.error(error);
            setErrorMessage('Something went wrong. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <section
            className="relative overflow-hidden pb-8 px-4"
            style={{
                backgroundColor: "#0F1117",
            }}
        >
            <div className='mx-auto max-w-[1200px]'>
                <Heading
                    title={sectionTitle}
                    subTitle={sectionSubTitle}
                    dotsPosition="afterSubtitle"
                    className="!px-0"
                />

                <div className='relative mt-8 md:mt-10 mx-auto w-full max-w-[720px] overflow-hidden rounded-[12px] border border-[#1B2230] bg-[linear-gradient(112deg,#15191F_0%,#141A23_48%,#15191F_100%)] px-3 md:px-6 py-5 md:py-7'>
                    <div
                        className='pointer-events-none absolute inset-0'
                        style={{
                            background: 'radial-gradient(ellipse 42% 56% at 50% 52%, rgba(34, 156, 255, 0.10) 0%, rgba(34, 156, 255, 0.03) 42%, transparent 82%)'
                        }}
                    />
                    <div className='relative z-10 max-w-[620px] mx-auto'>
                        <div className='pb-3 border-b border-[#2A3342]'>
                            <label className='block font-google-sans-medium text-[14px] md:text-[16px] text-white mb-2'>Name *</label>
                            <input
                                onChange={onChangeForm}
                                value={formData?.FirstName}
                                type="text"
                                name="FirstName"
                                placeholder='Name'
                                className='w-full bg-transparent outline-none border-none font-google-sans-regular text-[13px] md:text-[15px] text-white placeholder:text-[#9AA3B2]'
                            />
                        </div>

                        <div className='pt-4 pb-3 border-b border-[#2A3342]'>
                            <label className='block font-google-sans-medium text-[14px] md:text-[16px] text-white mb-2'>Phone Number *</label>
                            <input
                                onChange={(e: any) => {
                                    if (/^\d{0,10}$/.test(e.target.value)) onChangeForm(e)
                                }}
                                value={formData?.PhoneNumber}
                                type="text"
                                name="PhoneNumber"
                                placeholder='Phone Number'
                                className='w-full bg-transparent outline-none border-none font-google-sans-regular text-[13px] md:text-[15px] text-white placeholder:text-[#9AA3B2]'
                            />
                        </div>

                        <div className='pt-4 pb-3 border-b border-[#2A3342]'>
                            <label className='block font-google-sans-medium text-[14px] md:text-[16px] text-white mb-2'>Message</label>
                            <textarea
                                onChange={onChangeForm}
                                value={formData?.Message}
                                name="Message"
                                rows={4}
                                placeholder='Type your message here...'
                                className='w-full bg-transparent outline-none border-none resize-none font-google-sans-regular text-[13px] md:text-[15px] text-white placeholder:text-[#9AA3B2]'
                            />
                        </div>

                        {errorMessage.length !== 0 && <div className='text-start text-red-500 mt-3 text-sm'>{errorMessage}</div>}

                        {!loading ? (
                            <div className='mt-5 md:mt-6 flex justify-center'>
                                <button
                                    onClick={onSubmit}
                                    type="button"
                                    className='h-[40px] md:h-[48px] w-full max-w-[240px] md:max-w-[300px] rounded-[8px] font-google-sans-medium text-[14px] md:text-[16px] text-white'
                                    style={{
                                        background: "linear-gradient(90deg, #2A8BFD 0%, #35A7FF 100%)",
                                        boxShadow: "0 8px 20px rgba(42,139,253,0.26)"
                                    }}
                                >
                                    {buttonText}
                                </button>
                            </div>
                        ) : (
                            <div className='mt-5 md:mt-6 flex justify-center'>
                                <div className='loader'></div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ContactUs
